import {Props} from './model';
import {View} from 'react-native';
import * as React from 'react';

export const CustomView: React.FC<Props> = ({className, ...props}) => {
  const dataViewAttrs = {
    ...(className
      ? {
          dataSet: {
            class: className,
          },
        }
      : {}),
  };
  return <View {...props} {...dataViewAttrs} />;
};
